import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import get from 'lodash/get';

import { formatDateTime } from 'rebook/apps/utils/datetime';

import styles from './style.scss';


const BookRentPaymentStatus = ({ book, user }) => {
  const rentValidTill = get(book, 'rent_valid_till', null);
  const tillDate = formatDateTime(rentValidTill, 'DD.MM.YYYY');
  const userId = get(user, 'id', null);
  const isAudio = get(book, 'type', '') === 'audio';
  const text = isAudio ? 'слушать эту аудиокнигу' : 'читать эту книгу';

  return (
    <div className={classNames(styles.bookRentPaymentStatus, 'jest-rented-book-payment-status')}>
      <div className={styles.header}>
        <div className={styles.successImage} />
        <div className={styles.headerText}>
          <span><b>Аренда оформлена</b></span>
        </div>
        <div className={styles.headerTitle}>
          <span>
            Вы можете {text} <br className={styles.mobileTitleText} />
            до <b>{tillDate}</b>
          </span>
        </div>
      </div>
      <div className={styles.linkContainer}>
        <Link className="jest-link-to-user-books" to={{ pathname: `/profile/${userId}/`, state: { book } }}>
          <span className="link">
            Перейти в Мои книги
          </span>
          <span className={classNames('arrowRight', styles.arrow)} />
        </Link>
      </div>
    </div>
  );
};

BookRentPaymentStatus.propTypes = {
  book: PropTypes.shape({
    rent_valid_till: PropTypes.string.isRequired,
  }),
  user: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
};

export default BookRentPaymentStatus;
